// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"map-tooltip-module__tooltip___Xd1wM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/map-tooltip/map-tooltip.module.scss
// module id = 657
// module chunks = 0 1